(() => {
  if (customElements.get('ds-core-set-picker')) return;
  customElements.define('ds-core-set-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { if (this.hasAttribute('data-mobile-cleanup') && !this.mobileCleanup) this.setupMobile(); return; }
      this.ready = true;
      this.catalog = this.sizes?.[this.size] || JSON.parse(this.querySelector('[data-catalog]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.set = this.dataset.bundlePage === 'true' ? 'core' : 'single';
      const incoming = new URL(location.href).searchParams;
      const initialPlans = this.plans(this.catalog[this.set]);
      const explicitMode = incoming.get('ds_set_mode');
      this.purchase = this.catalog[this.set].requiresPlan || explicitMode === 'recurring' || (!explicitMode && initialPlans.length) ? 'recurring' : 'one-time';
      this.cadence = this.purchase === 'recurring' ? incoming.get('ds_set_cadence') || (!explicitMode ? initialPlans[0]?.cadence : null) : null;
      this.querySelector(`[name="ds_purchase"][value="${this.purchase}"]`).checked = true;
      this.changed = false;
      this.pending = false;
      this.form = this.querySelector('[data-set-form]');
      this.form.removeAttribute('action');
      this.querySelectorAll('[name="ds_set"]').forEach(r => r.addEventListener('change', () => { this.set = r.value; this.render(); }));
      this.querySelectorAll('[name="ds_purchase"]').forEach(r => r.addEventListener('change', () => {
        this.purchase = r.value;
        if (r.value === 'one-time') { this.cadence = null; this.changed = false; }
        this.render();
      }));
      this.el('interval').addEventListener('change', e => { this.cadence = e.target.value || null; this.changed = false; this.render(); });
      this.el('interval-jump').addEventListener('click', e => { e.preventDefault(); this.el('interval').scrollIntoView({block:'center'}); this.el('interval').focus(); });
      this.form.addEventListener('submit', e => this.submit(e));
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      document.querySelectorAll('[data-ds-set-colors] a').forEach(a => {
        const url = new URL(a.href);
        if (preview) url.searchParams.set('preview_theme_id', preview);
        a.href = url.href;
      });
      const cartURL = new URL(this.el('cart-link').href);
      if (preview) cartURL.searchParams.set('preview_theme_id', preview);
      this.el('cart-link').href = cartURL.href;
      this.render();
      if (this.hasAttribute('data-mobile-cleanup')) this.setupMobile();
      if (this.hasAttribute('data-elton-pilot')) this.setupPilot();
    }
    setupPilot() {
      if (this.pilotCleanup) return;
      const info = this.closest('.product__info-container');
      const root = info?.closest('.product');
      const wrapper = root?.querySelector('.product__media-wrapper');
      const original = wrapper?.querySelector('media-gallery');
      const title = info?.querySelector('.product__title');
      const rating = info?.querySelector('[data-fera-container="product_reviews_summary"]')?.closest('.shopify-block');
      const quality = info?.querySelector('.ds-trust-box') || (this.hasAttribute('data-casual-pilot') ? this : null);
      const member = this.el('member-disclosure');
      if (!wrapper || !original || !title || !quality || !member) return;
      const data = JSON.parse(this.querySelector('[data-pilot-images]').textContent);
      root.classList.add('ds-elton-cleanup');
      const media = matchMedia('(max-width:749px)');
      const header = document.createElement('div'); header.className = 'ds-pilot-heading';
      const gallery = document.createElement('section'); gallery.className = 'ds-pilot-gallery'; gallery.setAttribute('aria-label',data.gallery);
      const rail = document.createElement('div'); rail.className = 'ds-pilot-rail';
      const nav = document.createElement('div'); nav.className = 'ds-pilot-nav';
      const thumbs = document.createElement('div'); thumbs.className = 'ds-pilot-thumbs';
      const arrow = (label,symbol) => { const b=document.createElement('button'); b.type='button'; b.className='ds-pilot-arrow'; b.setAttribute('aria-label',label); b.textContent=symbol; return b; };
      const prev=arrow(data.previous,'‹'),next=arrow(data.next,'›');
      nav.append(prev,thumbs,next); gallery.append(rail,nav); wrapper.prepend(header,gallery);
      const dialog=document.createElement('dialog'); dialog.className='ds-pilot-zoom'; dialog.setAttribute('aria-label',data.gallery);
      const close=arrow(data.close,'×'),zoom=document.createElement('img'); dialog.append(close,zoom); root.append(dialog);
      close.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
      const positions=[title,rating,member].filter(Boolean).map(node=>{const anchor=document.createTextNode('');node.before(anchor);return{node,anchor};});
      const originalTitle=title.querySelector('h1').textContent;
      const subtitle=this.querySelector('[name="ds_set"][value="core"]').closest('.option').querySelector('.option-sub');
      const originalSubtitle=subtitle.textContent;
      let current=-1,index=0,buttons=[],slides=[],frame=0;
      const url=(src,width)=>{const u=new URL(src,location.href);u.searchParams.set('width',width);return u.href;};
      const imagesFor=key=>{
        const images=[...data[key]];
        if(key==='single'){
          const lead=images.findIndex(image=>/_Dress_Sock_Secondary\.jpg/i.test(image.src));
          if(lead>0)images.unshift(images.splice(lead,1)[0]);
        }
        return images;
      };
      const mark=()=>{
        buttons.forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));
        prev.disabled=index===0;next.disabled=index===slides.length-1;
        const selected=buttons[index];
        if(selected)thumbs.scrollTo({left:Math.max(0,selected.offsetLeft-thumbs.offsetLeft-thumbs.clientWidth/2+selected.offsetWidth/2),behavior:'auto'});
      };
      const select=i=>{index=Math.max(0,Math.min(i,slides.length-1));rail.scrollTo({left:slides[index].offsetLeft-rail.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});mark();};
      prev.addEventListener('click',()=>select(index-1));next.addEventListener('click',()=>select(index+1));
      rail.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{index=Math.round(rail.scrollLeft/Math.max(1,rail.clientWidth));index=Math.min(index,slides.length-1);mark();});},{passive:true});
      const build=()=>{
        current=this.set; index=0; buttons=[];slides=[];rail.replaceChildren();thumbs.replaceChildren();
        const images=imagesFor(current);
        images.forEach((image,i)=>{
          const slide=document.createElement('button');slide.type='button';slide.className='ds-pilot-slide';slide.setAttribute('aria-label',`${this.catalog[current].title} — ${i+1}`);
          const img=document.createElement('img');img.src=url(image.src,800);img.srcset=[400,600,800,1200].map(w=>`${url(image.src,w)} ${w}w`).join(',');img.sizes='calc(100vw - 30px)';img.width=image.width;img.height=image.height;img.alt=image.alt||this.catalog[current].title;img.loading=i===0?'eager':'lazy';if(i===0)img.fetchPriority='high';
          slide.append(img);slide.addEventListener('click',()=>{zoom.src=url(image.src,2000);zoom.alt=img.alt;dialog.showModal();close.focus();});rail.append(slide);slides.push(slide);
          const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',`${this.catalog[current].title} — ${i+1}`);const thumb=document.createElement('img');thumb.src=url(image.src,120);thumb.width=60;thumb.height=60;thumb.alt='';thumb.loading='lazy';button.append(thumb);button.addEventListener('click',()=>select(i));thumbs.append(button);buttons.push(button);
        });
        rail.scrollLeft=0;mark();
      };
      this.pilotSync=()=>{
        this.el('shipping').hidden=this.set!=='core'||this.el('set-shipping').hidden;
        if(!media.matches)return;
        if(current!==this.set)build();
        title.querySelector('h1').textContent=this.set==='core'?this.t('core'):originalTitle;
        if(rating)rating.hidden=this.set==='core' && this.dataset.bundlePage!=='true';
        if(root.querySelector('[data-ds-set-colors]'))root.querySelector('[data-ds-set-colors]').hidden=this.set==='core';
        this.el('shipping').hidden=this.set!=='core'||this.el('set-shipping').hidden;
      };
      const layout=()=>{
        root.classList.toggle('ds-elton-pilot',media.matches);
        header.hidden=gallery.hidden=!media.matches;
        if(media.matches){header.append(title);if(rating)header.append(rating);quality.after(member);member.classList.add('ds-pilot-member');subtitle.textContent=data.four;this.pilotSync();}
        else{positions.forEach(({node,anchor})=>anchor.after(node));title.querySelector('h1').textContent=originalTitle;if(rating)rating.hidden=false;if(root.querySelector('[data-ds-set-colors]'))root.querySelector('[data-ds-set-colors]').hidden=false;quality.after(member);member.classList.add('ds-pilot-member');this.pilotSync();subtitle.textContent=originalSubtitle;if(dialog.open)dialog.close();}
      };
      media.addEventListener('change',layout);layout();
      this.pilotCleanup=()=>{media.removeEventListener('change',layout);cancelAnimationFrame(frame);positions.forEach(({node,anchor})=>anchor.replaceWith(node));header.remove();gallery.remove();dialog.remove();root.classList.remove('ds-elton-pilot');this.pilotSync=null;this.pilotCleanup=null;};
    }

    setupMobile() {
      const bar = this.el('mobile-sticky'), button = this.el('sticky-add'), main = this.el('add');
      if (!bar || !button || !main) return;
      const media = matchMedia('(max-width:749px)');
      const info = this.closest('.product__info-container');
      const review = info?.querySelector('.ds-inline-review');
      const trust = info?.querySelector('.product__trust-badges');
      const shipping = this.el('shipping');
      const disclosure = this.el('member-disclosure');
      const relocations = [review,trust,shipping].filter(Boolean).map(node => {
        const anchor = document.createTextNode('');
        node.before(anchor);
        return {node,anchor};
      });
      const modals = [...document.querySelectorAll('[aria-modal="true"],dialog')];
      const sync = () => {
        const {product,recurring,plan} = this.state();
        const setName = this.set === 'core' ? this.t('core') : product.title;
        this.text('sticky-total', this.el('total').textContent);
        this.text('sticky-selection', this.t('summary',{pairs:this.t(this.set === 'core' ? 'pairs' : 'pair'),name:setName}));
        this.text('sticky-cadence', recurring ? this.t('per_delivery')+' · '+(plan ? this.cadenceLabel(plan.cadence) : this.t('choose_interval')) : this.t('one_time'));
        const label = main.disabled && recurring && !plan && product.available && !this.pending
          ? this.t('sticky_choose_interval') : main.disabled ? main.textContent : this.t('add');
        if (button.textContent !== label) button.textContent = label;
        button.disabled = main.disabled;
        button.setAttribute('aria-label', [label, this.el('sticky-selection').textContent, this.el('sticky-total').textContent, this.el('sticky-cadence').textContent].filter(Boolean).join('. '));
        const overlayOpen = modals.some(modal => {
          if (modal.matches('#rebuy-cart.is-visible')) return true;
          const rect = modal.getBoundingClientRect(), style = getComputedStyle(modal);
          return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && !modal.closest('[hidden],[aria-hidden="true"]');
        });
        bar.hidden = !media.matches || main.getBoundingClientRect().bottom >= 0 || overlayOpen;
      };
      let frame = 0;
      const schedule = () => { if (!frame) frame = requestAnimationFrame(() => { frame = 0; sync(); }); };
      const layout = () => {
        if (media.matches) {
          if (review) { this.after(review); review.setAttribute('data-mobile-relocated',''); }
          if (trust) main.after(trust);
          if (shipping) (trust || main).after(shipping);
        } else {
          relocations.forEach(({node,anchor}) => anchor.after(node));
          review?.removeAttribute('data-mobile-relocated');
        }
        disclosure.open = this.hasAttribute('data-elton-pilot') ? false : !media.matches;
        schedule();
      };
      const activate = () => { if (!main.disabled) main.click(); };
      button.addEventListener('click',activate);
      const mutation = new MutationObserver(schedule);
      mutation.observe(main,{attributes:true,childList:true,subtree:true});
      mutation.observe(this.querySelector('.buy-summary'),{childList:true,subtree:true});
      modals.forEach(modal => mutation.observe(modal,{attributes:true,attributeFilter:['class','style','hidden','aria-hidden','open']}));
      mutation.observe(document.body,{attributes:true,attributeFilter:['class','style']});
      const intersection = new IntersectionObserver(schedule);
      intersection.observe(main);
      window.addEventListener('scroll',schedule,{passive:true});
      window.addEventListener('resize',schedule,{passive:true});
      media.addEventListener('change',layout);
      this.mobileCleanup = () => {
        mutation.disconnect(); intersection.disconnect(); cancelAnimationFrame(frame);
        window.removeEventListener('scroll',schedule); window.removeEventListener('resize',schedule);
        media.removeEventListener('change',layout); button.removeEventListener('click',activate);
        relocations.forEach(({node,anchor}) => { if (anchor.isConnected) anchor.replaceWith(node); });
        review?.removeAttribute('data-mobile-relocated');
        bar.hidden = true;
        this.mobileCleanup = null;
      };
      layout();
    }
    disconnectedCallback() { this.pilotCleanup?.(); this.mobileCleanup?.(); }
    el(name) { return this.querySelector(`[data-${name}]`) || (this.hasAttribute('data-elton-pilot') ? this.closest('.product')?.querySelector(`[data-${name}]`) : null); }
    text(name, value) { const el = this.el(name); if (el) el.textContent = value; }
    t(key, values = {}) { return Object.entries(values).reduce((s, [k,v]) => s.replaceAll(`[${k}]`, v), this.labels[key]); }
    plans(product) {
      const list = product.plans.filter(p => p.cadence && /^\d+-month$/.test(p.cadence));
      return list.filter(p => list.filter(x => x.cadence === p.cadence).length === 1).sort((a,b) => parseInt(a.cadence) - parseInt(b.cadence));
    }
    cadenceLabel(value) { const n = parseInt(value); return n === 1 ? this.t('every_month') : this.t('every_months',{count:n}); }
    state() {
      const product = this.catalog[this.set], plans = this.plans(product);
      const recurring = this.purchase === 'recurring';
      const plan = recurring ? plans.find(p => p.cadence === this.cadence) : null;
      return {product, plans, recurring, plan, ready:Boolean(product.id && product.available && this.purchase && (!recurring ? !product.requiresPlan : plan))};
    }
    render() {
      if (this.hasAttribute('data-mixed-plans') && this.purchase === 'recurring' && !this.plans(this.catalog[this.set]).length) {
        this.purchase = ''; this.cadence = null; this.changed = false;
        this.querySelectorAll('[name="ds_purchase"]').forEach(r => { r.checked = false; });
      }
      if (this.hasAttribute('data-mixed-plans') && !this.purchase && this.plans(this.catalog[this.set]).length) {
        this.purchase = 'recurring';
        this.querySelector('[name="ds_purchase"][value="recurring"]').checked = true;
      }
      let {product, plans, recurring, plan, ready} = this.state();
      if (this.el('unavailable-plan')) this.el('unavailable-plan').hidden = Boolean(this.purchase);
      if (this.cadence && !plans.some(p => p.cadence === this.cadence)) { this.cadence = null; this.changed = true; }
      const first = plan || plans[0];
      const name = this.set === 'core' ? this.t('core') : product.title;
      const pairs = this.t(this.set === 'core' ? 'pairs' : 'pair');
      for (const key of ['single','core']) {
        const p = this.catalog[key], firstPlan = this.plans(p)[0];
        const target = this.el(`${key}-price`);
        if (target) {
          target.replaceChildren();
          if (!recurring && (key === 'core' || this.hasAttribute('data-elton-pilot')) && p.compare > p.price) {
            const compare = document.createElement('del'); compare.textContent = p.compareMoney; target.append(compare);
          }
          const amount = document.createElement('span'); amount.textContent = recurring && firstPlan ? firstPlan.money : p.money; target.append(amount);
          if (recurring && firstPlan) { const unit = document.createElement('small'); unit.textContent = this.t('per_delivery'); target.append(unit); }
        }
      }
      const bundle = this.catalog.core;
      this.text('set-saving', recurring && this.plans(bundle).length ? this.t('every_shipment') : bundle.compare > bundle.price ? `${this.t('save_prefix')} ${bundle.savingMoney}` : '');
      this.el('set-shipping').hidden = recurring || bundle.currency !== 'USD' || bundle.country !== 'US' || bundle.price < 9900;
      this.text('purchase-context',this.t('purchase_context',{name,pairs}));
      this.text('once-price', product.money);
      this.text('recurring-price', first?.money || '—');
      this.el('recurring-option').hidden = !plans.length;
      const saving = first && product.price ? Math.round((product.price-first.price)/product.price*100) : 0;
      this.text('recurring-saving',saving > 0 ? this.t('save_delivery',{percent:saving}) : this.t('per_delivery'));
      this.el('interval-wrap').hidden = !recurring;
      const select = this.el('interval');
      select.required = recurring; select.disabled = !recurring || this.pending;
      if (select.dataset.product !== String(product.id)) {
        select.replaceChildren(new Option(this.t('interval_placeholder'),''),...plans.map(p => new Option(this.cadenceLabel(p.cadence),p.cadence)));
        select.dataset.product = String(product.id);
      }
      select.value = this.cadence || '';
      select.setAttribute('aria-invalid',String(recurring && !ready && this.changed));
      this.text('interval-help',this.changed ? this.t('changed') : plan ? this.cadenceLabel(plan.cadence) : this.t('interval_help'));
      this.el('selection-help').hidden = !recurring || Boolean(plan);
      this.text('selection-help-text',this.t(this.set === 'core' ? 'core_selection' : 'single_selection')+' '+this.t(this.changed ? 'changed' : 'interval_help'));
      this.text('selected-copy',this.t('summary',{pairs,name}));
      this.text('shipment-detail',recurring ? (plan ? this.cadenceLabel(plan.cadence) : this.t('choose_interval'))+' · '+(this.set === 'core' ? this.t('every_shipment') : product.title) : this.set === 'core' ? this.t('set_contents') : this.t('one_shipment'));
      this.text('total',recurring ? first?.money || '—' : product.money);
      this.text('total-unit',this.t(recurring ? 'per_delivery' : 'total'));
      this.text('member-note',this.t(recurring ? 'included_saving' : 'member'));
      this.text('shipping',this.t(this.set === 'core' && !this.el('set-shipping').hidden ? 'free_shipping' : 'shipping'));
      const add = this.el('add');
      add.disabled = !ready || this.pending;
      add.textContent = this.pending ? this.t('adding') : !product.available ? this.t('sold_out') : !this.purchase ? this.t('choose_purchase') : !ready ? this.t('choose_interval') : recurring ? this.t('add_recurring') : `${this.t('add')} — ${product.money}`;
      add.setAttribute('aria-label',`${add.textContent}. ${name}. ${pairs}. ${recurring && first ? first.money+' '+this.t('per_delivery') : product.money}`);
      this.form.querySelector('[name="id"]').value = product.id || '';
      const planField = this.form.querySelector('[name="selling_plan"]');
      planField.value = plan?.id || ''; planField.disabled = !plan;
      document.querySelectorAll('[data-ds-set-colors] a').forEach(a => {
        const url = new URL(a.href);
        url.searchParams.delete('ds_set_mode'); url.searchParams.delete('ds_set_cadence');
        if (this.purchase) url.searchParams.set('ds_set_mode',this.purchase);
        if (recurring && this.cadence) url.searchParams.set('ds_set_cadence',this.cadence);
        a.href = url.href;
      });
      this.el('notice').hidden = true;
      if(this.hasAttribute('data-elton-pilot')) {
        let line=this.querySelector('.ds-recurring-summary');
        if(!line){line=document.createElement('p');line.className='ds-recurring-summary';line.setAttribute('aria-live','polite');this.el('add').before(line);}
        line.hidden=!recurring || !plan;
        line.textContent=plan ? plan.money+' · '+this.cadenceLabel(plan.cadence) : '';
      }
      this.pilotSync?.();
    }
    async submit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const {product, plan, ready} = this.state();
      if (this.pending || !ready) return;
      this.pending = true;
      this.render();
      this.querySelectorAll('input[type="radio"]').forEach(r => { r.dataset.wasDisabled = String(r.disabled); r.disabled = true; });
      const item = {id:product.id,quantity:1};
      if (plan) item.selling_plan = plan.id;
      let confirmed = false, uncertain = false;
      try {
        const result = await this.addItem(item);
        const added = result.items?.find(line => String(line.variant_id || line.id) === String(item.id) && String(line.selling_plan_allocation?.selling_plan?.id || '') === String(item.selling_plan || ''));
        if (!added) throw new TypeError('Unconfirmed cart add');
        confirmed = true;
        this.lastAdded = added;
      } catch (error) {
        uncertain = error instanceof TypeError || error instanceof SyntaxError;
        this.lastError = uncertain ? this.t('error') : error.message;
      }
      if (confirmed) await this.openCart();
      this.pending = false;
      this.querySelectorAll('input[type="radio"]').forEach(r => { r.disabled = r.dataset.wasDisabled === 'true'; });
      this.render();
      this.el('notice').hidden = false;
      this.text('notice-text',confirmed ? this.t('added') : this.lastError);
      if (!confirmed) {
        if (uncertain) this.el('add').disabled = true;
        this.el('notice').focus();
      }
    }
    async addItem(item) {
      if (window.Rebuy?.Cart?.addItem) {
        return new Promise((resolve,reject) => {
          const timeout = setTimeout(() => reject(new TypeError('Cart add timeout')),20000);
          window.Rebuy.Cart.addItem({items:[item]}, {
            success: result => { clearTimeout(timeout); resolve(result); },
            error: error => {
              clearTimeout(timeout);
              const response = error.cause?.res;
              reject(response ? new Error(response.description || response.message || this.t('error')) : new TypeError(this.t('error')));
            }
          });
        });
      }
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || this.t('error'));
      return result;
    }
    cartContainsAdded(cart) {
      const added = this.lastAdded;
      if (!added) return false;
      return cart?.items?.some(item =>
        String(item.variant_id || item.id) === String(added.variant_id || added.id) &&
        String(item.selling_plan_allocation?.selling_plan?.id || '') === String(added.selling_plan_allocation?.selling_plan?.id || '') &&
        item.quantity >= added.quantity
      );
    }
    async openCart() {
      try {
        const cart = window.Rebuy?.Cart, drawer = window.Rebuy?.SmartCart;
        if (!cart?.fetchShopifyCart || !drawer?.setCart || !drawer?.show) throw new Error('Cart drawer unavailable');
        for (let attempt = 0; attempt < 3; attempt++) {
          const current = await new Promise((resolve,reject) => {
            const timeout = setTimeout(() => reject(new Error('Cart refresh timeout')),3000);
            cart.fetchShopifyCart(value => { clearTimeout(timeout); resolve(value); });
          });
          if (this.cartContainsAdded(current) && drawer.status === 'ready') {
            drawer.setCart(current);
            await new Promise(resolve => setTimeout(resolve,100));
            if (this.cartContainsAdded(drawer.cart)) {
              drawer.show();
              return;
            }
          }
          if (attempt < 2) await new Promise(resolve => setTimeout(resolve,250));
        }
      } catch {}
      location.assign(this.el('cart-link').href);
    }
  });
})();








